/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetPatientForProviderByIdResponseDto,
  GetProvidersOfFiltersResponseDto,
  PatientListResponseDto,
  PatientResponseDto,
  PatientsPaginationRequestDto,
  UpdateProfileUrlRequestDto,
  UpdateSignatureRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetPatientForProviderByIdResponseDtoFromJSON,
    GetPatientForProviderByIdResponseDtoToJSON,
    GetProvidersOfFiltersResponseDtoFromJSON,
    GetProvidersOfFiltersResponseDtoToJSON,
    PatientListResponseDtoFromJSON,
    PatientListResponseDtoToJSON,
    PatientResponseDtoFromJSON,
    PatientResponseDtoToJSON,
    PatientsPaginationRequestDtoFromJSON,
    PatientsPaginationRequestDtoToJSON,
    UpdateProfileUrlRequestDtoFromJSON,
    UpdateProfileUrlRequestDtoToJSON,
    UpdateSignatureRequestDtoFromJSON,
    UpdateSignatureRequestDtoToJSON,
} from '../models/index';

export interface GetAllPatientsNextPageTokenRequest {
    patientsPaginationRequestDto: PatientsPaginationRequestDto;
}

export interface GetAppointmentsRequest {
    startDate?: Date;
    endDate?: Date;
    providerIds?: string;
}

export interface GetPatientByPatientIdRequest {
    patientId: string;
    fetchRxntInfo?: boolean;
}

export interface GetPatientByPatientIdForProviderRequest {
    patientId: string;
}

export interface RestrictPatientRequest {
    patientId: string;
}

export interface UnrestrictPatientRequest {
    patientId: string;
}

export interface UpdateProfileUrlRequest {
    updateProfileUrlRequestDto: UpdateProfileUrlRequestDto;
}

export interface UpdateSignatureRequest {
    updateSignatureRequestDto: UpdateSignatureRequestDto;
}

/**
 * 
 */
export class PatientApi extends runtime.BaseAPI {

    /**
     * Mark patient for deletion and will delete after 30 days
     */
    async deletePatientRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark patient for deletion and will delete after 30 days
     */
    async deletePatient(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePatientRaw(initOverrides);
    }

    /**
     * Get all patients with pagination, search, and filter options
     * Get all patients with pagination and filters
     */
    async getAllPatientsNextPageTokenRaw(requestParameters: GetAllPatientsNextPageTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientListResponseDto>> {
        if (requestParameters['patientsPaginationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'patientsPaginationRequestDto',
                'Required parameter "patientsPaginationRequestDto" was null or undefined when calling getAllPatientsNextPageToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/query/nextPageToken`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PatientsPaginationRequestDtoToJSON(requestParameters['patientsPaginationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get all patients with pagination, search, and filter options
     * Get all patients with pagination and filters
     */
    async getAllPatientsNextPageToken(requestParameters: GetAllPatientsNextPageTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientListResponseDto> {
        const response = await this.getAllPatientsNextPageTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s appointments
     */
    async getAppointmentsRaw(requestParameters: GetAppointmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<object>>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['providerIds'] != null) {
            queryParameters['providerIds'] = requestParameters['providerIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/appointments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get patient\'s appointments
     */
    async getAppointments(requestParameters: GetAppointmentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<object>> {
        const response = await this.getAppointmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get patient by patient ID
     */
    async getPatientByPatientIdRaw(requestParameters: GetPatientByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientByPatientId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fetchRxntInfo'] != null) {
            queryParameters['fetchRxntInfo'] = requestParameters['fetchRxntInfo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/detail/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient by patient ID
     */
    async getPatientByPatientId(requestParameters: GetPatientByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientResponseDto> {
        const response = await this.getPatientByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get patient by patient ID for provider with data sharing status
     */
    async getPatientByPatientIdForProviderRaw(requestParameters: GetPatientByPatientIdForProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPatientForProviderByIdResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientByPatientIdForProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/provider/shared-patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPatientForProviderByIdResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient by patient ID for provider with data sharing status
     */
    async getPatientByPatientIdForProvider(requestParameters: GetPatientByPatientIdForProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPatientForProviderByIdResponseDto> {
        const response = await this.getPatientByPatientIdForProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get providers of filters
     */
    async getProvidersOfFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetProvidersOfFiltersResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/appointments/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetProvidersOfFiltersResponseDtoFromJSON));
    }

    /**
     * Get providers of filters
     */
    async getProvidersOfFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetProvidersOfFiltersResponseDto>> {
        const response = await this.getProvidersOfFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Restore patient from deletion
     */
    async restorePatientRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/restore`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Restore patient from deletion
     */
    async restorePatient(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.restorePatientRaw(initOverrides);
    }

    /**
     * Restricts a patient account, preventing them from logging in. Any active session will be terminated immediately.
     * Restrict a patient account
     */
    async restrictPatientRaw(requestParameters: RestrictPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling restrictPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/{patientId}/restrict`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Restricts a patient account, preventing them from logging in. Any active session will be terminated immediately.
     * Restrict a patient account
     */
    async restrictPatient(requestParameters: RestrictPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.restrictPatientRaw(requestParameters, initOverrides);
    }

    /**
     * Restores access for a previously restricted patient account.
     * Unrestrict a patient account
     */
    async unrestrictPatientRaw(requestParameters: UnrestrictPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling unrestrictPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/{patientId}/unrestrict`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Restores access for a previously restricted patient account.
     * Unrestrict a patient account
     */
    async unrestrictPatient(requestParameters: UnrestrictPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unrestrictPatientRaw(requestParameters, initOverrides);
    }

    /**
     * Update patient profile URL
     */
    async updateProfileUrlRaw(requestParameters: UpdateProfileUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateProfileUrlRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateProfileUrlRequestDto',
                'Required parameter "updateProfileUrlRequestDto" was null or undefined when calling updateProfileUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/profile-url`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileUrlRequestDtoToJSON(requestParameters['updateProfileUrlRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update patient profile URL
     */
    async updateProfileUrl(requestParameters: UpdateProfileUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProfileUrlRaw(requestParameters, initOverrides);
    }

    /**
     * Update patient digital signature
     */
    async updateSignatureRaw(requestParameters: UpdateSignatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateSignatureRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateSignatureRequestDto',
                'Required parameter "updateSignatureRequestDto" was null or undefined when calling updateSignature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/signature`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSignatureRequestDtoToJSON(requestParameters['updateSignatureRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update patient digital signature
     */
    async updateSignature(requestParameters: UpdateSignatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSignatureRaw(requestParameters, initOverrides);
    }

}
